
import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_ROLES,
    GET_ROLE_DETAIL,
    ADD_NEW_ROLE,
    UPDATE_ROLE,
    DELETE_ROLE,
    GET_PERMISSIONS,
} from "./actionTypes"

import {
    getRolesSuccess,
    getRolesFail,
    getRoleDetailSuccess,
    getRoleDetailFail,
    addNewRoleSuccess,
    addNewRoleFail,
    updateRoleSuccess,
    updateRoleFail,
    deleteRoleSuccess,
    deleteRoleFail,
    getPermissionsSuccess,
    getPermissionsFail,
} from "./actions"

import {
    getRoles,
    getRoleDetail,
    addNewRole,
    updateRole,
    deleteRole,
    getPermissionsGrouped,
} from "../../helpers/fakebackend_helper"

function* fetchRoles() {
    try {
        const response = yield call(getRoles)
        yield put(getRolesSuccess(response))
    } catch (error) {
        yield put(getRolesFail(error))
    }
}

function* fetchRoleDetail({ payload: id }) {
    try {
        const response = yield call(getRoleDetail, id)
        yield put(getRoleDetailSuccess(response))
    } catch (error) {
        yield put(getRoleDetailFail(error))
    }
}

function* onAddNewRole({ payload: role }) {
    try {
        const response = yield call(addNewRole, role)
        yield put(addNewRoleSuccess(response))
    } catch (error) {
        yield put(addNewRoleFail(error))
    }
}

function* onUpdateRole({ payload: role }) {
    try {
        const response = yield call(updateRole, role)
        yield put(updateRoleSuccess(response))
    } catch (error) {
        yield put(updateRoleFail(error))
    }
}

function* onDeleteRole({ payload: id }) {
    try {
        yield call(deleteRole, id)
        yield put(deleteRoleSuccess(id))
    } catch (error) {
        yield put(deleteRoleFail(error))
    }
}

function* fetchPermissions() {
    try {
        const response = yield call(getPermissionsGrouped)
        yield put(getPermissionsSuccess(response))
    } catch (error) {
        yield put(getPermissionsFail(error))
    }
}

function* rolesSaga() {
    yield takeEvery(GET_ROLES, fetchRoles)
    yield takeEvery(GET_ROLE_DETAIL, fetchRoleDetail)
    yield takeEvery(ADD_NEW_ROLE, onAddNewRole)
    yield takeEvery(UPDATE_ROLE, onUpdateRole)
    yield takeEvery(DELETE_ROLE, onDeleteRole)
    yield takeEvery(GET_PERMISSIONS, fetchPermissions)
}

export default rolesSaga
